import React, { useMemo } from "react";
import { } from 'react-redux';

import {
  Image,
} from '@lockerpm/design';


import {
} from "@ant-design/icons";

const ProgrammingLanguage = (props) => {
  const {
    name = '',
    label = '',
    height = 20,
    width = 20,
    className = '',
    isShowLabel = true
  } = props;

  const languageName = useMemo(() => {
    if (label) {
      return label
    }
    if (name === 'javascript') {
      return 'NodeJS';
    }
    if (name === 'csharp') {
      return '.NET';
    }
    return name || 'Other'
  }, [label, name])

  const Icon = require(`../../assets/images/programming-languages/${name && name !== 'go' ? name : 'terminal'}.svg`)

  return (
    <div className="flex items-center">
      <Image
        style={{ height: height, width: width }}
        preview={false}
        src={Icon}
      />
      {
        isShowLabel && <p className={`capitalize ml-2 ${className}`}>
          {languageName}
        </p>
      }
    </div>
  );
}

export default ProgrammingLanguage;